import { render } from "./form-add.vue?vue&type=template&id=6e439fb0&scoped=true"
import script from "./form-add.vue?vue&type=script&lang=js"
export * from "./form-add.vue?vue&type=script&lang=js"

import "./form-add.vue?vue&type=style&index=0&id=6e439fb0&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e439fb0"],['__file',"src/components/admin-dashboard/modals/forms/form-add.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e439fb0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e439fb0', __exports__)) {
    api.reload('6e439fb0', __exports__)
  }
  
  module.hot.accept("./form-add.vue?vue&type=template&id=6e439fb0&scoped=true", () => {
    api.rerender('6e439fb0', render)
  })

}


export default __exports__